import React from 'react';
import { Buildings } from 'react-bootstrap-icons';
import './WelfareBanner.css';

const WelfareBanner: React.FC = () => {
  const subject = encodeURIComponent(
    'Richiesta preventivo per progetto welfare'
  );
  const body = encodeURIComponent(
    `Gentile Annalisa,\n\n` +
      `ti contatto per richiedere un preventivo per un progetto welfare presso la nostra sede.\n\n` +
      `--- DATI ORGANIZZAZIONE ---\n` +
      `Nome scuola / azienda: \n` +
      `Referente: \n` +
      `Telefono di contatto: \n` +
      `Città / Indirizzo sede: \n\n` +
      `--- PROGETTO ---\n` +
      `Numero stimato di partecipanti: \n` +
      `Tipologia di intervento desiderato (es. corso posturale, yoga, mindfulness, altro): \n` +
      `Preferenza orari / giorni: \n` +
      `Note aggiuntive: \n\n` +
      `Resto in attesa di un tuo riscontro.\n\n` +
      `Cordiali saluti`
  );

  const handleClick = () => {
    window.location.href = `mailto:info@benessereposturale.it?subject=${subject}&body=${body}`;
  };

  return (
    <div className="welfare-banner-wrapper">
      <button
        className="welfare-banner-pill"
        onClick={handleClick}
        aria-label="Richiedi un preventivo per il tuo progetto welfare"
      >
        <Buildings size={22} className="welfare-banner-icon" />
        <div className="welfare-banner-text">
          <span className="welfare-banner-title">
            SEI UNA SCUOLA O UN'AZIENDA?
          </span>
          <span className="welfare-banner-sub">
            Chiedimi un preventivo per il tuo progetto welfare direttamente
            nella tua sede
          </span>
        </div>
        <span className="welfare-banner-arrow">✉ Scrivimi</span>
      </button>
    </div>
  );
};

export default WelfareBanner;
